import request from '@/utils/request'
const apiPath = '/course/courseSubjectBarrier'
import { downloadBlob } from '@/utils/download'
const courseSubjectBarrierApi = {
  /**
   * 新增【课程管理闯关模式】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【课程管理闯关模式】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【课程管理闯关模式】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchForList(query) {
    return request.get(apiPath + '/tee/list', { params: query })
  },
  /**
   * 
   * 查看【课程管理闯关模式】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【课程管理闯关模式】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  batchState(data) {
    return request.post(apiPath + '/batchState', data, { isFormData: 1 })
  },
}
export default courseSubjectBarrierApi
